export default function getDomainName () {
  if (typeof window === 'undefined') return undefined;
  const host = window.location.hostname;
  return host.substring(host.lastIndexOf('.', host.lastIndexOf('.') - 1) + 1);
}
